import type { SeatQuantityChangeResult } from "@/domain/model/AccountBilling";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";
import type { IdempotencyKeyFactory } from "../port/IdempotencyKeyFactory";

export class DecreaseAccountSeats {
  constructor(
    private readonly service: AccountManagementService,
    private readonly idempotencyKeyFactory: IdempotencyKeyFactory,
  ) {}

  execute(
    targetSeatQuantity: number,
    signal?: AbortSignal,
  ): Promise<SeatQuantityChangeResult> {
    return this.service.decreaseSeats(
      targetSeatQuantity,
      this.idempotencyKeyFactory.create(),
      signal,
    );
  }
}
